import React, { useEffect, useState } from 'react';
import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';
import aboutbg from "../../../../src/assets/img/bg-about.webp";

import ConteudoPrincipal from "./Sections/conteudo-principal";
import Informacoes from "./Sections/sobre";
import Depoimentos from "./Sections/depoimentos";

import { Helmet } from 'react-helmet-async';
import FeiraProfissoes from './Sections/feira-de-profissoes';
import TextoFinal from './Sections/texto-final';
import { PageAboutInterface } from '../../Services/types';
import { fetchData } from '../../../Api';
import Galeria from '../../Components/galeria';
import Video from './Sections/video';

const Sobre: React.FC<any> = ({initialData} : any) => {
    const title = 'Quem Somos';

    const breadcrumb = [{
        name: title,
        slug: 'quem-somos'
    }];

    const [about, setAbout] = useState<PageAboutInterface | null>(initialData?.about);
        
    useEffect(() => {
        if (initialData?.about) return;
        const loadData = async () => {
            const response = await fetchData("quem-somos");
            if(response){
            if (response.about) setAbout(response.about);
            }
        };
        
        loadData();
    }, []);
    
    return (
        <>
            <Helmet>
                <title>{title} - Uniexpo</title>
            </Helmet>

            <MainLayout>
                <Header title={title} breadcrumb={breadcrumb} image={aboutbg} />
                {about && 
                    <>
                        <ConteudoPrincipal title={about.title} content={about.content} />

                        <Informacoes />

                        {about.galeria.length > 0 &&
                            <Galeria galeria={about.galeria} />
                        }

                        <FeiraProfissoes content={about.content2}/>

                        {about.video &&
                            <Video video={about.video} title={about.titulo_video} />
                        }

                        {about.depoimentos.length > 0 &&
                            <Depoimentos depoimentos={about.depoimentos} />
                        }
                        <TextoFinal />
                    </>
                }
            </ MainLayout>
        </>
    );
};

export default Sobre;
